import React, { useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import { Helmet } from 'react-helmet-async';

const PublicLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  // Use transparent navbar on the root landing page if not scrolled
  const isLandingPage = location.pathname === '/';
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100vw', overflowX: 'hidden' }}>
      <Helmet>
        <title>Akmo Books | All-in-One Cloud ERP: POS, Payroll & Accounting</title>
        <meta name="description" content="Streamline your business with Akmo Books. The ultimate cloud ERP featuring smart POS, automated GST, payroll, inventory, and real-time bank reconciliation." />
      </Helmet>
      <Navbar transparentOnTop={isLandingPage} />
      
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          pt: isLandingPage ? 0 : { xs: '70px', md: '80px' }, // Add padding top only if not landing page
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {children || <Outlet />}
      </Box>
      
      <Footer />
    </Box>
  );
};

export default PublicLayout;
